class ConsumerToolbarController  {
    constructor() {
        this.query = this.container.query;
        this.prompt = this.container.prompt;
        this.consumerId = this.container.consumerId;
    }
    add(){return (this.container || this.container.prompt).add({consumerId: this.consumerId});}
    load(){return this.container.load.apply(this.container, arguments);}
}

class ConsumerToolbar{
    constructor(){
        this.bindings= {
            container: '<',
            addMessage: '@',
            findMessage: '@'
        };
        this.controller = ConsumerToolbarController;
    }

    templateUrl($element, $attrs) {
        return $attrs.templateUrl || 'consumer-toolbar.html'
    }
}

export { ConsumerToolbarController, ConsumerToolbar}

angular.module('emun.consumer').component('consumerToolbar', new ConsumerToolbar());